import produce from 'immer';
import {State, Actions} from './interfaces';
import {
  GET_PARCELS,
  GET_PARCELS_SUCCESS,
  GET_PARCELS_FAILED,
  GET_PARCELS_WITH_ID,
  GET_PARCELS_WITH_ID_SUCCESS,
  GET_PARCELS_WITH_ID_FAILED,
  GET_LOGS_SUCCESS,
  GET_LOGS_FAILED,
  GET_LOGS,
  CANCEL_PARCEL,
  CANCEL_PARCEL_SUCCESS,
  CANCEL_PARCEL_FAILED,
  GET_PARCEL_INVENTORY_ITEMS,
  GET_PARCEL_INVENTORY_ITEMS_SUCCESS,
  GET_PARCEL_INVENTORY_ITEMS_FAILED,
  GET_INVENTORY_ITEMS_WITH_SERIAL,
  GET_INVENTORY_ITEMS_WITH_SERIAL_SUCCESS,
  GET_INVENTORY_ITEMS_WITH_SERIAL_FAILED,
  GET_INVENTORY_ITEMS_WITH_STATUS,
  GET_INVENTORY_ITEMS_WITH_STATUS_SUCCESS,
  GET_INVENTORY_ITEMS_WITH_STATUS_FAILED,
  CLEAN_PARCEL_INVENTORY_ITEMS,
  RELOCATE_BY_ITEM,
  RELOCATE_BY_ITEM_SUCCESS,
  RELOCATE_BY_ITEM_FAILED,
  UPDATE_MULTI_INVENTORY_ITEMS_STATUS,
  UPDATE_MULTI_INVENTORY_ITEMS_STATUS_SUCCESS,
  UPDATE_MULTI_INVENTORY_ITEMS_STATUS_FAILED,
  GET_RONAD_PARCELS_WITH_ID,
  GET_RONAD_PARCELS_WITH_ID_SUCCESS,
  GET_RONAD_PARCELS_WITH_ID_FAILED,
  GET_ALL_PARCELS_REPORT,
  GET_ALL_PARCELS_REPORT_SUCCESS,
  GET_ALL_PARCELS_REPORT_FAILED,
  UPDATE_PARCELS,
  UPDATE_PARCELS_SUCCESS,
  UPDATE_PARCELS_FAILED,
  CREATE_PARCELS,
  CREATE_PARCELS_SUCCESS,
  CREATE_PARCELS_FAILED
} from './constants';
import {
  GET_ALL_ORDERS_REPORT,
  GET_ALL_ORDERS_REPORT_FAILED,
  GET_ALL_ORDERS_REPORT_SUCCESS,
} from '../orders/constants';

export const initialState: State = {
  parcelsList: [],
  allParcelsReport: [],
  inventoryItemsLoading: false,
  inventoryItems: [],
  inventoryItemsCount: 0,
  inventoryItemsError: '',
  inventoryItemsWithSerialLoading: false,
  inventoryItemsWithSerial: [],
  inventoryItemsWithSerialError: '',
  inventoryItemsWithStatusLoading: false,
  inventoryItemsWithStatus: [],
  inventoryItemsWithStatusError: '',
  relocateLoading: false,
  parcel: {},
  logs: [],
  count: 0,
  locatedCardCount: 0,
  submittedCardCount: 0,
  conflictCardCount: 0,
  progressCardCount: 0,
  loading: false,
  error: '',
};

export const ParcelsReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_PARCELS:
        draft.loading = true;
        break;
      case GET_PARCELS_SUCCESS:
        draft.parcelsList = action.data;
        draft.count = action.count;
        draft.locatedCardCount = action.locatedCardCount;
        draft.submittedCardCount = action.submittedCardCount;
        draft.progressCardCount = action.progressCardCount;
        draft.conflictCardCount = action.conflictCardCount;
        draft.loading = false;
        break;
      case GET_PARCELS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_PARCEL_INVENTORY_ITEMS:
        draft.inventoryItemsLoading = true;
        break;
      case GET_PARCEL_INVENTORY_ITEMS_SUCCESS:
        draft.inventoryItems = action.data;
        draft.inventoryItemsCount = action.count;
        draft.inventoryItemsLoading = false;
        break;
      case GET_PARCEL_INVENTORY_ITEMS_FAILED:
        draft.inventoryItemsError = action.error;
        draft.inventoryItemsLoading = false;
        break;

      case GET_ALL_PARCELS_REPORT:
        draft.loading = true;
        break;
      case GET_ALL_PARCELS_REPORT_SUCCESS:
        draft.allParcelsReport = action.data;
        draft.loading = false;
        break;
      case GET_ALL_PARCELS_REPORT_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case   CREATE_PARCELS:
        draft.loading = true;
        break;
      case CREATE_PARCELS_SUCCESS:
        draft.loading = false;
        break;
      case CREATE_PARCELS_FAILED:
        draft.loading = false;
        break;

      case GET_INVENTORY_ITEMS_WITH_SERIAL:
        draft.inventoryItemsWithSerialLoading = true;
        break;
      case GET_INVENTORY_ITEMS_WITH_SERIAL_SUCCESS:
        draft.inventoryItemsWithSerial = action.data;
        draft.inventoryItemsWithSerialLoading = false;
        break;
      case GET_INVENTORY_ITEMS_WITH_SERIAL_FAILED:
        draft.inventoryItemsWithSerialError = action.error;
        draft.inventoryItemsWithSerialLoading = false;
        break;

      case GET_INVENTORY_ITEMS_WITH_STATUS:
        draft.inventoryItemsWithStatusLoading = true;
        break;
      case GET_INVENTORY_ITEMS_WITH_STATUS_SUCCESS:
        draft.inventoryItemsWithStatus = action.data;
        draft.inventoryItemsWithStatusLoading = false;
        break;
      case GET_INVENTORY_ITEMS_WITH_STATUS_FAILED:
        draft.inventoryItemsWithStatusError = action.error;
        draft.inventoryItemsWithStatusLoading = false;
        break;

      case CLEAN_PARCEL_INVENTORY_ITEMS:
        draft.inventoryItems = [];
        draft.inventoryItemsCount = 0;
        break;

      case GET_PARCELS_WITH_ID:
        draft.loading = true;
        break;
      case GET_PARCELS_WITH_ID_SUCCESS:
        draft.parcel = action.data;
        draft.loading = false;
        break;
      case GET_PARCELS_WITH_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_RONAD_PARCELS_WITH_ID:
        draft.loading = true;
        break;
      case GET_RONAD_PARCELS_WITH_ID_SUCCESS:
        draft.parcel = action.data;
        draft.loading = false;
        break;
      case GET_RONAD_PARCELS_WITH_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_LOGS:
        draft.loading = true;
        break;
      case GET_LOGS_SUCCESS:
        draft.logs = action.data;
        draft.loading = false;
        break;
      case GET_LOGS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case CANCEL_PARCEL:
        draft.loading = true;
        break;
      case CANCEL_PARCEL_SUCCESS:
        draft.loading = false;
        break;
      case CANCEL_PARCEL_FAILED:
        draft.loading = false;
        draft.error = action.error;
        break;
      case UPDATE_PARCELS:
        draft.loading = true;
        break;
      case UPDATE_PARCELS_SUCCESS:
        draft.loading = false;
        break;
      case UPDATE_PARCELS_FAILED:
        draft.loading = false;
        break;

      case RELOCATE_BY_ITEM:
        draft.loading = true;
        break;
      case RELOCATE_BY_ITEM_SUCCESS:
        draft.loading = false;
        break;
      case RELOCATE_BY_ITEM_FAILED:
        draft.loading = false;
        draft.error = action.error;
        break;
      case UPDATE_MULTI_INVENTORY_ITEMS_STATUS:
        draft.loading = true;
        break;
      case UPDATE_MULTI_INVENTORY_ITEMS_STATUS_SUCCESS:
        draft.loading = false;
        break;
      case UPDATE_MULTI_INVENTORY_ITEMS_STATUS_FAILED:
        draft.loading = false;
        break;
      default:
        break;
    }
  });
export default ParcelsReducer;
